export default function slider( el ) {
	if ( ! el ) {
		return;
	}
	const slider = el.querySelector( '.b-slider-element' );
	if ( slider ) {
		const flkty = new Flickity( slider, {
			cellAlign: 'left',
			wrapAround: true,
			setGallerySize: true,
			autoPlay: false,
			pageDots: false,
			prevNextButtons: false, // Disable default prev/next buttons
		} );

		// Custom previous button
		const prevButton = el.querySelector( '.b-slider-prev' );
		if ( prevButton ) {
			prevButton.addEventListener( 'click', function() {
				flkty.previous();
			} );
		}

		// Custom next button
		const nextButton = el.querySelector( '.b-slider-next' );
		if ( nextButton ) {
			nextButton.addEventListener( 'click', function() {
				flkty.next();
			} );
		}
	}
}
